import { render } from "./OutletComponent.vue?vue&type=template&id=4ff259df"
import script from "./OutletComponent.vue?vue&type=script&lang=js"
export * from "./OutletComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Outlet/OutletComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ff259df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ff259df', __exports__)) {
    api.reload('4ff259df', __exports__)
  }
  
  module.hot.accept("./OutletComponent.vue?vue&type=template&id=4ff259df", () => {
    api.rerender('4ff259df', render)
  })

}


export default __exports__